/* eslint-disable max-lines */

import * as fromActions from '../actions/AddDirectory';

import { AddDirectory, initialState } from '../types/state/AddDirectory';

import { AsyncOpState } from 'vrlcm-gui-types';
import { joinErrorMessages } from 'vrlcm-gui-utils';

export default function(
  state: AddDirectory = initialState,
  action: fromActions.Actions
): AddDirectory {
  switch (action.type) {
    case fromActions.INITIALIZE_AD_WIZARD_PAGE:
      return {
        ...state,
        wizardInitializeState: AsyncOpState.Inprogress
      };
    case fromActions.INITIALIZE_AD_WIZARD_PAGE_FAIL:
      return {
        ...state,
        wizardInitializeState: AsyncOpState.Failed
      };
    case fromActions.INITIALIZE_AD_WIZARD_PAGE_SUCCESS:
      return {
        ...state,
        wizardData: action.payload.wizardData
          ? action.payload.wizardData
          : state.wizardData,
        wizardState: action.payload.wizardState,
        wizardInitializeState: AsyncOpState.Completed,
        vidmDetails: action.payload.vidmDetails
      };
    case fromActions.UPDATE_WIZARD_DATA:
      return {
        ...state,
        wizardData: action.payload
      };
    case fromActions.UPDATE_WIZARD_STEP_VALIDITY:
      if (state.wizardState) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            steps: state.wizardState.steps.map((s, i) =>
              i !== action.payload.step
                ? s
                : { ...s, valid: action.payload.valid }
            )
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_WIZARD_LEVEL_STATE:
      if (state.wizardState) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            wizardLevelState: {
              ...state.wizardState.wizardLevelState,
              ...action.payload
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_DIRECTORY_CONFIG_ID:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            directoryConfigId: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_WIZARD_CURRENT_STEP:
      if (state.wizardState) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            currentStep: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_WIZARD_STEP_STATE:
      if (state.wizardState) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            steps: state.wizardState.steps.map((s, i) =>
              i !== action.payload.step
                ? s
                : {
                    ...s,
                    ...action.payload.state
                  }
            )
          }
        };
      } else {
        return state;
      }
    case fromActions.DISABLE_AND_CLEAR_STEP_STATE_FROM_STEP:
      if (state.wizardState) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            steps: state.wizardState.steps.map((s, i) =>
              i < action.payload
                ? s
                : {
                    ...s,
                    disabled: true,
                    state: undefined
                  }
            )
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_DIRECTORY_DATA:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            directoryData: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_PREVIEW_STEP_DATA:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            previewData: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_DOMAIN_SELECTION_DATA:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            domainSelectionData: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_MAP_ATTRIBUTE_DATA:
      if (state.wizardData && action.payload.userAttributeMappings) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            mapAttributeData: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.UPDATE_TEST_CONNECTION_DATA:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            testConnectionData: action.payload
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_UPDATE_SYNC_NESTED_GROUP_FLAG:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              syncNestedGroup: action.payload
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_ADD_NEW_GROUP:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: [
                ...state.wizardData.groupSelectionData.selectedGroups,
                {
                  groupDN: '',
                  selectedSubGroups: [],
                  allSubGroupsSelected: false,
                  syncResult: {
                    syncState: AsyncOpState.NotStarted
                  }
                }
              ]
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_REMOVE_GROUP:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.filter(
                (tg, i) => i !== action.payload
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_CHANGE_GROUP_DN:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                (tg, i) =>
                  i !== action.payload.index
                    ? tg
                    : {
                        ...tg,
                        groupDN: action.payload.groupDN,
                        selectedSubGroups: [],
                        allSubGroupsSelected: false,
                        syncResult: {
                          syncState: AsyncOpState.NotStarted
                        }
                      }
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_TRIGGER_GROUP_SYNC:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                tg =>
                  tg.groupDN !== action.payload
                    ? tg
                    : {
                        ...tg,
                        syncResult: {
                          syncState: AsyncOpState.Inprogress
                        }
                      }
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_TRIGGER_GROUP_SYNC_COMPLETED:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                tg =>
                  tg.groupDN !== action.payload.groupDN
                    ? tg
                    : {
                        ...tg,
                        groupDN: action.payload.groupDN,
                        syncResult: {
                          syncState: AsyncOpState.Completed,
                          data: {
                            totalSubGroups: action.payload.subGroups.length,
                            moreThan1000Groups:
                              action.payload.moreThan1000Groups
                          }
                        }
                      }
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_TRIGGER_GROUP_SYNC_FAILED:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                tg =>
                  tg.groupDN !== action.payload.groupDN
                    ? tg
                    : {
                        ...tg,
                        syncResult: {
                          syncState: AsyncOpState.Failed,
                          errorMessage: joinErrorMessages(
                            action.payload.errors || [],
                            'Group sync failed'
                          )
                        }
                      }
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_NAVIGATE_TO_SUB_GROUP_SELECTION:
      if (state.wizardState && state.wizardData) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            groupMappingPageState: {
              groupMappingPageActive: true,
              group:
                state.wizardData.groupSelectionData.selectedGroups[
                  action.payload
                ]
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_SELECT_ALL_SUB_GROUPS:
      if (state.wizardState && state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                g =>
                  g.groupDN === action.payload
                    ? {
                        ...g,
                        selectedSubGroups: [],
                        allSubGroupsSelected: true
                      }
                    : g
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_UNSELECT_ALL_SUB_GROUPS:
      if (state.wizardState && state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            groupSelectionData: {
              ...state.wizardData.groupSelectionData,
              selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                g =>
                  g.groupDN === action.payload
                    ? {
                        ...g,
                        selectedSubGroups: [],
                        allSubGroupsSelected: false
                      }
                    : g
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_NAVIGATE_TO_MAIN_PAGE:
      if (state.wizardState && state.wizardData) {
        return {
          ...state,
          wizardState: {
            ...state.wizardState,
            groupMappingPageState: {
              ...state.wizardState.groupMappingPageState,
              groupMappingPageActive: false
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.GROUP_SELECTION_UPDATE_SUB_GROUP_SELECTION:
      if (state.wizardData) {
        const parentGroupIdx = state.wizardData.groupSelectionData.selectedGroups.findIndex(
          t => t.groupDN === action.payload.parentGroupDN
        );
        if (parentGroupIdx !== -1) {
          return {
            ...state,
            wizardData: {
              ...state.wizardData,
              groupSelectionData: {
                ...state.wizardData.groupSelectionData,
                selectedGroups: state.wizardData.groupSelectionData.selectedGroups.map(
                  (t, i) =>
                    parentGroupIdx !== i
                      ? t
                      : {
                          ...t,
                          selectedSubGroups:
                            t.syncResult.data &&
                            t.syncResult.data.totalSubGroups ===
                              action.payload.selectedGroups.length
                              ? []
                              : action.payload.selectedGroups,
                          allSubGroupsSelected: !!(
                            t.syncResult.data &&
                            t.syncResult.data.totalSubGroups ===
                              action.payload.selectedGroups.length
                          )
                        }
                )
              }
            }
          };
        } else {
          return state;
        }
      } else {
        return state;
      }
    case fromActions.USER_SELECTION_ADD_NEW_USER:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            userSelectionData: {
              ...state.wizardData.userSelectionData,
              userDNs: [...state.wizardData.userSelectionData.userDNs, '']
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.USER_SELECTION_REMOVE_USER:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            userSelectionData: {
              ...state.wizardData.userSelectionData,
              userDNs: state.wizardData.userSelectionData.userDNs.filter(
                (u, i) => i !== action.payload
              )
            }
          }
        };
      } else {
        return state;
      }
    case fromActions.USER_SELECTION_CHANGE_USER:
      if (state.wizardData) {
        return {
          ...state,
          wizardData: {
            ...state.wizardData,
            userSelectionData: {
              ...state.wizardData.userSelectionData,
              userDNs: state.wizardData.userSelectionData.userDNs.map((u, i) =>
                i !== action.payload.index ? u : action.payload.userDN
              )
            }
          }
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}
